module.exports = __webpack_public_path__ + "img/img_golf_app1_en.c7424435.png";